<div
  class="time-picker"
  [class.time-picker--invalid]="invalid"
  [class.time-picker--disabled]="disabled"
  [class.time-picker--compact]="compact"
>
  <ptl-icon class="time-picker__icon" [icon]="LucideClock" [size]="'s'"></ptl-icon>
  <input
    class="time-picker__field"
    type="text"
    inputmode="numeric"
    maxlength="2"
    placeholder="--"
    [value]="hour"
    [disabled]="disabled"
    [attr.aria-label]="hourAriaLabel ?? ('translations.global.ariaLabels.hours' | transloco)"
    (input)="onHourInput($event)"
    (blur)="onBlur()"
  />
  <span class="time-picker__separator">:</span>
  <input
    class="time-picker__field"
    type="text"
    inputmode="numeric"
    maxlength="2"
    placeholder="--"
    [value]="minute"
    [disabled]="disabled"
    [attr.aria-label]="minuteAriaLabel ?? ('translations.global.ariaLabels.minutes' | transloco)"
    (input)="onMinuteInput($event)"
    (blur)="onBlur()"
  />
</div>
